<template>
    <div class="header-sub">
		<a href="/" class="logo">
			<img src="../../assets/logo-sub.png" />
		</a>
		<div class="header-sub-r" v-if="userId&&isShowStatus">
			<span>您好，{{userInfo.mail}}</span>
			<span class="line">|</span>
			<span class="loginout" @click="toLoginout">退出</span>
		</div>
    </div>
</template>

<script>
import qs from 'qs'
import { post,ajaxParam } from '../../units/request.js'
export default {
  name: '',
  props: {
	isShowStatus: {
		type: Boolean,
		default: false,
	}
  },
  components: {
  },
  data(){
	return {
		userId: '',
        userInfo: {}
	}
  },
  methods: {
	//获取用户信息积分信息
    async getUserIntegral(){
        let url = 'v1/integral/getUserIntegral'
        let param = {
            userId: this.userId,
            token:localStorage.getItem('token'),
            activityId: this.activityId
        }
        ajaxParam(param)
        const res = await post(url, qs.stringify(param))
            //console.log(res)
        if(res.data.code==200) {
            this.userInfo = res.data.entity
        } else {
            this.$message.error(res.data.msg)
        }
	},
	toLoginout(){
            this.$confirm('确定要退出登录？','温馨提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async()=>{
                localStorage.removeItem('user')
                localStorage.removeItem('userId')
                localStorage.removeItem('token')
                localStorage.removeItem('radioDialog')
				let isLoginStudent = localStorage.getItem('isLoginStudent')
				if(isLoginStudent==1) {
					this.$router.push('/loginstudent')
				} else {
					this.$router.push('/login')
				}
				setTimeout(()=>{
					localStorage.removeItem('isLoginStudent')
				},300)

            }).catch(()=>{

            })
        }
  },
  created(){
        this.userId = localStorage.getItem('userId')
		this.activityId = localStorage.getItem('activityId')
        if(this.userId){
            this.getUserIntegral()
        }
}
}
</script>

<style scoped>
    .header-sub{
		width: 100%;
		height: 89px;
		box-shadow: 0px 3px 12px 0px rgba(217, 217, 217, 0.47);
		display:flex;
		align-items: center;
		justify-content: space-between;
	}
	.logo{
		width: 287px;
		height: 43px;
		margin-left: 60px
	}
	.header-sub-r{
		margin-right: 60px
	}
	.header-sub-r .line{
		padding: 0 10px
	}
	.loginout{
		cursor: pointer;
	}
</style>
